/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as fullscreenRouteRouteImport } from './routes/(fullscreen)/route'
import { Route as appRouteRouteImport } from './routes/(app)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CourseEditorPublicUuidRouteImport } from './routes/course-editor/$publicUuid'
import { Route as fullscreenWelcomeRouteImport } from './routes/(fullscreen)/welcome'
import { Route as appSimulatorsRouteImport } from './routes/(app)/simulators'
import { Route as appAcademyRouteImport } from './routes/(app)/academy'
import { Route as appAboutRouteImport } from './routes/(app)/about'
import { Route as appHomeRouteRouteImport } from './routes/(app)/home/route'
import { Route as appCoursesRouteRouteImport } from './routes/(app)/courses/route'
import { Route as appAdminRouteRouteImport } from './routes/(app)/admin/route'
import { Route as appUsersIndexRouteImport } from './routes/(app)/users/index'
import { Route as appSupportIndexRouteImport } from './routes/(app)/support/index'
import { Route as appSchoolClassesIndexRouteImport } from './routes/(app)/school-classes/index'
import { Route as appHomeIndexRouteImport } from './routes/(app)/home/index'
import { Route as appGroupsIndexRouteImport } from './routes/(app)/groups/index'
import { Route as appCoursesIndexRouteImport } from './routes/(app)/courses/index'
import { Route as appAdminIndexRouteImport } from './routes/(app)/admin/index'
import { Route as OauthPipedriveCallbackRouteImport } from './routes/oauth/pipedrive.callback'
import { Route as OauthGithubCallbackRouteImport } from './routes/oauth/github.callback'
import { Route as OauthFortnoxCallbackRouteImport } from './routes/oauth/fortnox.callback'
import { Route as appSupportInstallationRouteImport } from './routes/(app)/support/installation'
import { Route as appSupportContactRouteImport } from './routes/(app)/support/contact'
import { Route as appSettingsIntegrationsRouteImport } from './routes/(app)/settings/integrations'
import { Route as appSchoolClassesIdRouteImport } from './routes/(app)/school-classes/$id'
import { Route as appHomeYoutubeRouteImport } from './routes/(app)/home/youtube'
import { Route as appHomeStatsRouteImport } from './routes/(app)/home/stats'
import { Route as appHomeStartRouteImport } from './routes/(app)/home/start'
import { Route as appHomeNewsRouteImport } from './routes/(app)/home/news'
import { Route as appGroupsCreateRouteImport } from './routes/(app)/groups/create'
import { Route as appAdminUsersRouteImport } from './routes/(app)/admin/users'
import { Route as appAdminToplistRouteImport } from './routes/(app)/admin/toplist'
import { Route as appAdminStatsRouteImport } from './routes/(app)/admin/stats'
import { Route as appAdminSimulatorsRouteImport } from './routes/(app)/admin/simulators'
import { Route as appAdminSimulatorFleetRouteImport } from './routes/(app)/admin/simulator-fleet'
import { Route as appAdminSchoolsRouteImport } from './routes/(app)/admin/schools'
import { Route as appAdminRundataRouteImport } from './routes/(app)/admin/rundata'
import { Route as appAdminPartnersRouteImport } from './routes/(app)/admin/partners'
import { Route as appAdminOrganizationsRouteImport } from './routes/(app)/admin/organizations'
import { Route as appAdminMapRouteImport } from './routes/(app)/admin/map'
import { Route as appAdminLicenseUpdatesRouteImport } from './routes/(app)/admin/license-updates'
import { Route as appAdminExportCommentsRouteImport } from './routes/(app)/admin/export-comments'
import { Route as appAdminExerciseLeaderboardRouteImport } from './routes/(app)/admin/exercise-leaderboard'
import { Route as appAdminCourseEditorStatsRouteImport } from './routes/(app)/admin/course-editor-stats'
import { Route as appAdminClientsRouteImport } from './routes/(app)/admin/clients'
import { Route as appAdminClientDistributionRouteImport } from './routes/(app)/admin/client-distribution'
import { Route as appAdminBillingRouteImport } from './routes/(app)/admin/billing'
import { Route as appUsersCreateRouteRouteImport } from './routes/(app)/users/create/route'
import { Route as appUsersIdRouteRouteImport } from './routes/(app)/users/$id/route'
import { Route as appGroupsIdRouteRouteImport } from './routes/(app)/groups/$id/route'
import { Route as appAdminTicketsRouteRouteImport } from './routes/(app)/admin/tickets/route'
import { Route as appAdminAcademyRouteRouteImport } from './routes/(app)/admin/academy/route'
import { Route as appUsersCreateIndexRouteImport } from './routes/(app)/users/create/index'
import { Route as appUsersIdIndexRouteImport } from './routes/(app)/users/$id/index'
import { Route as appHomeAcademyIndexRouteImport } from './routes/(app)/home/academy/index'
import { Route as appGroupsIdIndexRouteImport } from './routes/(app)/groups/$id/index'
import { Route as appCoursesTypeIndexRouteImport } from './routes/(app)/courses/$type/index'
import { Route as appAdminTicketsIndexRouteImport } from './routes/(app)/admin/tickets/index'
import { Route as appAdminOrganizationsIndexRouteImport } from './routes/(app)/admin/organizations/index'
import { Route as appAdminFrameratesIndexRouteImport } from './routes/(app)/admin/framerates/index'
import { Route as appAdminCompetitionsIndexRouteImport } from './routes/(app)/admin/competitions/index'
import { Route as appAdminAcademyIndexRouteImport } from './routes/(app)/admin/academy/index'
import { Route as appUsersCreateNewRouteImport } from './routes/(app)/users/create/new'
import { Route as appUsersCreateImportRouteImport } from './routes/(app)/users/create/import'
import { Route as appUsersIdTachographRouteImport } from './routes/(app)/users/$id/tachograph'
import { Route as appUsersIdProfileRouteImport } from './routes/(app)/users/$id/profile'
import { Route as appUsersIdDrivingRecordRouteImport } from './routes/(app)/users/$id/driving-record'
import { Route as appUsersIdCoursesRouteImport } from './routes/(app)/users/$id/courses'
import { Route as appGroupsIdTachographRouteImport } from './routes/(app)/groups/$id/tachograph'
import { Route as appGroupsIdDrivingHistoryRouteImport } from './routes/(app)/groups/$id/driving-history'
import { Route as appGroupsIdCoursesRouteImport } from './routes/(app)/groups/$id/courses'
import { Route as appAdminTicketsFeedbackRouteImport } from './routes/(app)/admin/tickets/feedback'
import { Route as appAdminTicketsBugreportRouteImport } from './routes/(app)/admin/tickets/bugreport'
import { Route as appAdminCompetitionsCreateRouteImport } from './routes/(app)/admin/competitions/create'
import { Route as appAdminCompetitionsIdRouteImport } from './routes/(app)/admin/competitions/$id'
import { Route as appAdminBugBugIdRouteImport } from './routes/(app)/admin/bug.$bugId'
import { Route as appAdminAcademyCoursesRouteImport } from './routes/(app)/admin/academy/courses'
import { Route as fullscreenUsersIdEditRouteRouteImport } from './routes/(fullscreen)/users/$id/edit/route'
import { Route as fullscreenGroupsIdEditRouteRouteImport } from './routes/(fullscreen)/groups/$id/edit/route'
import { Route as appCoursesTypePublicCourseUuidIndexRouteImport } from './routes/(app)/courses_.$type.$publicCourseUuid/index'
import { Route as appAdminTicketsIdIndexRouteImport } from './routes/(app)/admin/tickets/$id/index'
import { Route as appAdminOrganizationsOrganizationIdIndexRouteImport } from './routes/(app)/admin/organizations/$organizationId/index'
import { Route as appAdminCompetitionsIdIndexRouteImport } from './routes/(app)/admin/competitions/$id/index'
import { Route as appAdminAcademyStatsIndexRouteImport } from './routes/(app)/admin/academy/stats/index'
import { Route as fullscreenUsersIdEditPersonalInfoRouteImport } from './routes/(fullscreen)/users/$id/edit/personal-info'
import { Route as fullscreenUsersIdEditCoursesRouteImport } from './routes/(fullscreen)/users/$id/edit/courses'
import { Route as fullscreenUsersIdEditAccountRouteImport } from './routes/(fullscreen)/users/$id/edit/account'
import { Route as fullscreenHomeAcademyLectureIdSegmentIdRouteImport } from './routes/(fullscreen)/home/academy/$lectureId/$segmentId'
import { Route as fullscreenGroupsIdEditUsersRouteImport } from './routes/(fullscreen)/groups/$id/edit/users'
import { Route as fullscreenGroupsIdEditSettingsRouteImport } from './routes/(fullscreen)/groups/$id/edit/settings'
import { Route as fullscreenGroupsIdEditCoursesRouteImport } from './routes/(fullscreen)/groups/$id/edit/courses'
import { Route as appAdminCompetitionsIdEditRouteImport } from './routes/(app)/admin/competitions/$id.edit'
import { Route as appAdminAcademyStatsLectureIdIndexRouteImport } from './routes/(app)/admin/academy/stats/$lectureId/index'
import { Route as fullscreenAdminTicketsIdScreenshotBugIdRouteImport } from './routes/(fullscreen)/admin.tickets.$id.screenshot.$bugId'
import { Route as appCoursesTypePublicCourseUuidLessonsPublicLessonUuidRouteImport } from './routes/(app)/courses_.$type.$publicCourseUuid/lessons.$publicLessonUuid'
import { Route as appAdminOrganizationsOrganizationIdSchoolsSchoolIdRouteImport } from './routes/(app)/admin/organizations/$organizationId/schools/$schoolId'
import { Route as appAdminAcademyStatsLectureIdSchoolIdRouteImport } from './routes/(app)/admin/academy/stats/$lectureId/$schoolId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateRoute = ActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const fullscreenRouteRoute = fullscreenRouteRouteImport.update({
  id: '/(fullscreen)',
  getParentRoute: () => rootRouteImport,
} as any)
const appRouteRoute = appRouteRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CourseEditorPublicUuidRoute = CourseEditorPublicUuidRouteImport.update({
  id: '/course-editor/$publicUuid',
  path: '/course-editor/$publicUuid',
  getParentRoute: () => rootRouteImport,
} as any)
const fullscreenWelcomeRoute = fullscreenWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => fullscreenRouteRoute,
} as any)
const appSimulatorsRoute = appSimulatorsRouteImport.update({
  id: '/simulators',
  path: '/simulators',
  getParentRoute: () => appRouteRoute,
} as any)
const appAcademyRoute = appAcademyRouteImport.update({
  id: '/academy',
  path: '/academy',
  getParentRoute: () => appRouteRoute,
} as any)
const appAboutRoute = appAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => appRouteRoute,
} as any)
const appHomeRouteRoute = appHomeRouteRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => appRouteRoute,
} as any)
const appCoursesRouteRoute = appCoursesRouteRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => appRouteRoute,
} as any)
const appAdminRouteRoute = appAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => appRouteRoute,
} as any)
const appUsersIndexRoute = appUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => appRouteRoute,
} as any)
const appSupportIndexRoute = appSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => appRouteRoute,
} as any)
const appSchoolClassesIndexRoute = appSchoolClassesIndexRouteImport.update({
  id: '/school-classes/',
  path: '/school-classes/',
  getParentRoute: () => appRouteRoute,
} as any)
const appHomeIndexRoute = appHomeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appHomeRouteRoute,
} as any)
const appGroupsIndexRoute = appGroupsIndexRouteImport.update({
  id: '/groups/',
  path: '/groups/',
  getParentRoute: () => appRouteRoute,
} as any)
const appCoursesIndexRoute = appCoursesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appCoursesRouteRoute,
} as any)
const appAdminIndexRoute = appAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const OauthPipedriveCallbackRoute = OauthPipedriveCallbackRouteImport.update({
  id: '/oauth/pipedrive/callback',
  path: '/oauth/pipedrive/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthGithubCallbackRoute = OauthGithubCallbackRouteImport.update({
  id: '/oauth/github/callback',
  path: '/oauth/github/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthFortnoxCallbackRoute = OauthFortnoxCallbackRouteImport.update({
  id: '/oauth/fortnox/callback',
  path: '/oauth/fortnox/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const appSupportInstallationRoute = appSupportInstallationRouteImport.update({
  id: '/support/installation',
  path: '/support/installation',
  getParentRoute: () => appRouteRoute,
} as any)
const appSupportContactRoute = appSupportContactRouteImport.update({
  id: '/support/contact',
  path: '/support/contact',
  getParentRoute: () => appRouteRoute,
} as any)
const appSettingsIntegrationsRoute = appSettingsIntegrationsRouteImport.update({
  id: '/settings/integrations',
  path: '/settings/integrations',
  getParentRoute: () => appRouteRoute,
} as any)
const appSchoolClassesIdRoute = appSchoolClassesIdRouteImport.update({
  id: '/school-classes/$id',
  path: '/school-classes/$id',
  getParentRoute: () => appRouteRoute,
} as any)
const appHomeYoutubeRoute = appHomeYoutubeRouteImport.update({
  id: '/youtube',
  path: '/youtube',
  getParentRoute: () => appHomeRouteRoute,
} as any)
const appHomeStatsRoute = appHomeStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => appHomeRouteRoute,
} as any)
const appHomeStartRoute = appHomeStartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => appHomeRouteRoute,
} as any)
const appHomeNewsRoute = appHomeNewsRouteImport.update({
  id: '/news',
  path: '/news',
  getParentRoute: () => appHomeRouteRoute,
} as any)
const appGroupsCreateRoute = appGroupsCreateRouteImport.update({
  id: '/groups/create',
  path: '/groups/create',
  getParentRoute: () => appRouteRoute,
} as any)
const appAdminUsersRoute = appAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminToplistRoute = appAdminToplistRouteImport.update({
  id: '/toplist',
  path: '/toplist',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminStatsRoute = appAdminStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminSimulatorsRoute = appAdminSimulatorsRouteImport.update({
  id: '/simulators',
  path: '/simulators',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminSimulatorFleetRoute = appAdminSimulatorFleetRouteImport.update({
  id: '/simulator-fleet',
  path: '/simulator-fleet',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminSchoolsRoute = appAdminSchoolsRouteImport.update({
  id: '/schools',
  path: '/schools',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminRundataRoute = appAdminRundataRouteImport.update({
  id: '/rundata',
  path: '/rundata',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminPartnersRoute = appAdminPartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminOrganizationsRoute = appAdminOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminMapRoute = appAdminMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminLicenseUpdatesRoute = appAdminLicenseUpdatesRouteImport.update({
  id: '/license-updates',
  path: '/license-updates',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminExportCommentsRoute = appAdminExportCommentsRouteImport.update({
  id: '/export-comments',
  path: '/export-comments',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminExerciseLeaderboardRoute =
  appAdminExerciseLeaderboardRouteImport.update({
    id: '/exercise-leaderboard',
    path: '/exercise-leaderboard',
    getParentRoute: () => appAdminRouteRoute,
  } as any)
const appAdminCourseEditorStatsRoute =
  appAdminCourseEditorStatsRouteImport.update({
    id: '/course-editor-stats',
    path: '/course-editor-stats',
    getParentRoute: () => appAdminRouteRoute,
  } as any)
const appAdminClientsRoute = appAdminClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminClientDistributionRoute =
  appAdminClientDistributionRouteImport.update({
    id: '/client-distribution',
    path: '/client-distribution',
    getParentRoute: () => appAdminRouteRoute,
  } as any)
const appAdminBillingRoute = appAdminBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appUsersCreateRouteRoute = appUsersCreateRouteRouteImport.update({
  id: '/users/create',
  path: '/users/create',
  getParentRoute: () => appRouteRoute,
} as any)
const appUsersIdRouteRoute = appUsersIdRouteRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => appRouteRoute,
} as any)
const appGroupsIdRouteRoute = appGroupsIdRouteRouteImport.update({
  id: '/groups/$id',
  path: '/groups/$id',
  getParentRoute: () => appRouteRoute,
} as any)
const appAdminTicketsRouteRoute = appAdminTicketsRouteRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminAcademyRouteRoute = appAdminAcademyRouteRouteImport.update({
  id: '/academy',
  path: '/academy',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appUsersCreateIndexRoute = appUsersCreateIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appUsersCreateRouteRoute,
} as any)
const appUsersIdIndexRoute = appUsersIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appUsersIdRouteRoute,
} as any)
const appHomeAcademyIndexRoute = appHomeAcademyIndexRouteImport.update({
  id: '/academy/',
  path: '/academy/',
  getParentRoute: () => appHomeRouteRoute,
} as any)
const appGroupsIdIndexRoute = appGroupsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appGroupsIdRouteRoute,
} as any)
const appCoursesTypeIndexRoute = appCoursesTypeIndexRouteImport.update({
  id: '/$type/',
  path: '/$type/',
  getParentRoute: () => appCoursesRouteRoute,
} as any)
const appAdminTicketsIndexRoute = appAdminTicketsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appAdminTicketsRouteRoute,
} as any)
const appAdminOrganizationsIndexRoute =
  appAdminOrganizationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appAdminOrganizationsRoute,
  } as any)
const appAdminFrameratesIndexRoute = appAdminFrameratesIndexRouteImport.update({
  id: '/framerates/',
  path: '/framerates/',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminCompetitionsIndexRoute =
  appAdminCompetitionsIndexRouteImport.update({
    id: '/competitions/',
    path: '/competitions/',
    getParentRoute: () => appAdminRouteRoute,
  } as any)
const appAdminAcademyIndexRoute = appAdminAcademyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appAdminAcademyRouteRoute,
} as any)
const appUsersCreateNewRoute = appUsersCreateNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => appUsersCreateRouteRoute,
} as any)
const appUsersCreateImportRoute = appUsersCreateImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => appUsersCreateRouteRoute,
} as any)
const appUsersIdTachographRoute = appUsersIdTachographRouteImport.update({
  id: '/tachograph',
  path: '/tachograph',
  getParentRoute: () => appUsersIdRouteRoute,
} as any)
const appUsersIdProfileRoute = appUsersIdProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => appUsersIdRouteRoute,
} as any)
const appUsersIdDrivingRecordRoute = appUsersIdDrivingRecordRouteImport.update({
  id: '/driving-record',
  path: '/driving-record',
  getParentRoute: () => appUsersIdRouteRoute,
} as any)
const appUsersIdCoursesRoute = appUsersIdCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => appUsersIdRouteRoute,
} as any)
const appGroupsIdTachographRoute = appGroupsIdTachographRouteImport.update({
  id: '/tachograph',
  path: '/tachograph',
  getParentRoute: () => appGroupsIdRouteRoute,
} as any)
const appGroupsIdDrivingHistoryRoute =
  appGroupsIdDrivingHistoryRouteImport.update({
    id: '/driving-history',
    path: '/driving-history',
    getParentRoute: () => appGroupsIdRouteRoute,
  } as any)
const appGroupsIdCoursesRoute = appGroupsIdCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => appGroupsIdRouteRoute,
} as any)
const appAdminTicketsFeedbackRoute = appAdminTicketsFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => appAdminTicketsRouteRoute,
} as any)
const appAdminTicketsBugreportRoute =
  appAdminTicketsBugreportRouteImport.update({
    id: '/bugreport',
    path: '/bugreport',
    getParentRoute: () => appAdminTicketsRouteRoute,
  } as any)
const appAdminCompetitionsCreateRoute =
  appAdminCompetitionsCreateRouteImport.update({
    id: '/competitions/create',
    path: '/competitions/create',
    getParentRoute: () => appAdminRouteRoute,
  } as any)
const appAdminCompetitionsIdRoute = appAdminCompetitionsIdRouteImport.update({
  id: '/competitions/$id',
  path: '/competitions/$id',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminBugBugIdRoute = appAdminBugBugIdRouteImport.update({
  id: '/bug/$bugId',
  path: '/bug/$bugId',
  getParentRoute: () => appAdminRouteRoute,
} as any)
const appAdminAcademyCoursesRoute = appAdminAcademyCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => appAdminAcademyRouteRoute,
} as any)
const fullscreenUsersIdEditRouteRoute =
  fullscreenUsersIdEditRouteRouteImport.update({
    id: '/users/$id/edit',
    path: '/users/$id/edit',
    getParentRoute: () => fullscreenRouteRoute,
  } as any)
const fullscreenGroupsIdEditRouteRoute =
  fullscreenGroupsIdEditRouteRouteImport.update({
    id: '/groups/$id/edit',
    path: '/groups/$id/edit',
    getParentRoute: () => fullscreenRouteRoute,
  } as any)
const appCoursesTypePublicCourseUuidIndexRoute =
  appCoursesTypePublicCourseUuidIndexRouteImport.update({
    id: '/courses_/$type/$publicCourseUuid/',
    path: '/courses/$type/$publicCourseUuid/',
    getParentRoute: () => appRouteRoute,
  } as any)
const appAdminTicketsIdIndexRoute = appAdminTicketsIdIndexRouteImport.update({
  id: '/$id/',
  path: '/$id/',
  getParentRoute: () => appAdminTicketsRouteRoute,
} as any)
const appAdminOrganizationsOrganizationIdIndexRoute =
  appAdminOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/$organizationId/',
    path: '/$organizationId/',
    getParentRoute: () => appAdminOrganizationsRoute,
  } as any)
const appAdminCompetitionsIdIndexRoute =
  appAdminCompetitionsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appAdminCompetitionsIdRoute,
  } as any)
const appAdminAcademyStatsIndexRoute =
  appAdminAcademyStatsIndexRouteImport.update({
    id: '/stats/',
    path: '/stats/',
    getParentRoute: () => appAdminAcademyRouteRoute,
  } as any)
const fullscreenUsersIdEditPersonalInfoRoute =
  fullscreenUsersIdEditPersonalInfoRouteImport.update({
    id: '/personal-info',
    path: '/personal-info',
    getParentRoute: () => fullscreenUsersIdEditRouteRoute,
  } as any)
const fullscreenUsersIdEditCoursesRoute =
  fullscreenUsersIdEditCoursesRouteImport.update({
    id: '/courses',
    path: '/courses',
    getParentRoute: () => fullscreenUsersIdEditRouteRoute,
  } as any)
const fullscreenUsersIdEditAccountRoute =
  fullscreenUsersIdEditAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => fullscreenUsersIdEditRouteRoute,
  } as any)
const fullscreenHomeAcademyLectureIdSegmentIdRoute =
  fullscreenHomeAcademyLectureIdSegmentIdRouteImport.update({
    id: '/home/academy/$lectureId/$segmentId',
    path: '/home/academy/$lectureId/$segmentId',
    getParentRoute: () => fullscreenRouteRoute,
  } as any)
const fullscreenGroupsIdEditUsersRoute =
  fullscreenGroupsIdEditUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => fullscreenGroupsIdEditRouteRoute,
  } as any)
const fullscreenGroupsIdEditSettingsRoute =
  fullscreenGroupsIdEditSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => fullscreenGroupsIdEditRouteRoute,
  } as any)
const fullscreenGroupsIdEditCoursesRoute =
  fullscreenGroupsIdEditCoursesRouteImport.update({
    id: '/courses',
    path: '/courses',
    getParentRoute: () => fullscreenGroupsIdEditRouteRoute,
  } as any)
const appAdminCompetitionsIdEditRoute =
  appAdminCompetitionsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => appAdminCompetitionsIdRoute,
  } as any)
const appAdminAcademyStatsLectureIdIndexRoute =
  appAdminAcademyStatsLectureIdIndexRouteImport.update({
    id: '/stats/$lectureId/',
    path: '/stats/$lectureId/',
    getParentRoute: () => appAdminAcademyRouteRoute,
  } as any)
const fullscreenAdminTicketsIdScreenshotBugIdRoute =
  fullscreenAdminTicketsIdScreenshotBugIdRouteImport.update({
    id: '/admin/tickets/$id/screenshot/$bugId',
    path: '/admin/tickets/$id/screenshot/$bugId',
    getParentRoute: () => fullscreenRouteRoute,
  } as any)
const appCoursesTypePublicCourseUuidLessonsPublicLessonUuidRoute =
  appCoursesTypePublicCourseUuidLessonsPublicLessonUuidRouteImport.update({
    id: '/courses_/$type/$publicCourseUuid/lessons/$publicLessonUuid',
    path: '/courses/$type/$publicCourseUuid/lessons/$publicLessonUuid',
    getParentRoute: () => appRouteRoute,
  } as any)
const appAdminOrganizationsOrganizationIdSchoolsSchoolIdRoute =
  appAdminOrganizationsOrganizationIdSchoolsSchoolIdRouteImport.update({
    id: '/$organizationId/schools/$schoolId',
    path: '/$organizationId/schools/$schoolId',
    getParentRoute: () => appAdminOrganizationsRoute,
  } as any)
const appAdminAcademyStatsLectureIdSchoolIdRoute =
  appAdminAcademyStatsLectureIdSchoolIdRouteImport.update({
    id: '/stats/$lectureId/$schoolId',
    path: '/stats/$lectureId/$schoolId',
    getParentRoute: () => appAdminAcademyRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/login': typeof LoginRoute
  '/admin': typeof appAdminRouteRouteWithChildren
  '/courses': typeof appCoursesRouteRouteWithChildren
  '/home': typeof appHomeRouteRouteWithChildren
  '/about': typeof appAboutRoute
  '/academy': typeof appAcademyRoute
  '/simulators': typeof appSimulatorsRoute
  '/welcome': typeof fullscreenWelcomeRoute
  '/course-editor/$publicUuid': typeof CourseEditorPublicUuidRoute
  '/admin/academy': typeof appAdminAcademyRouteRouteWithChildren
  '/admin/tickets': typeof appAdminTicketsRouteRouteWithChildren
  '/groups/$id': typeof appGroupsIdRouteRouteWithChildren
  '/users/$id': typeof appUsersIdRouteRouteWithChildren
  '/users/create': typeof appUsersCreateRouteRouteWithChildren
  '/admin/billing': typeof appAdminBillingRoute
  '/admin/client-distribution': typeof appAdminClientDistributionRoute
  '/admin/clients': typeof appAdminClientsRoute
  '/admin/course-editor-stats': typeof appAdminCourseEditorStatsRoute
  '/admin/exercise-leaderboard': typeof appAdminExerciseLeaderboardRoute
  '/admin/export-comments': typeof appAdminExportCommentsRoute
  '/admin/license-updates': typeof appAdminLicenseUpdatesRoute
  '/admin/map': typeof appAdminMapRoute
  '/admin/organizations': typeof appAdminOrganizationsRouteWithChildren
  '/admin/partners': typeof appAdminPartnersRoute
  '/admin/rundata': typeof appAdminRundataRoute
  '/admin/schools': typeof appAdminSchoolsRoute
  '/admin/simulator-fleet': typeof appAdminSimulatorFleetRoute
  '/admin/simulators': typeof appAdminSimulatorsRoute
  '/admin/stats': typeof appAdminStatsRoute
  '/admin/toplist': typeof appAdminToplistRoute
  '/admin/users': typeof appAdminUsersRoute
  '/groups/create': typeof appGroupsCreateRoute
  '/home/news': typeof appHomeNewsRoute
  '/home/start': typeof appHomeStartRoute
  '/home/stats': typeof appHomeStatsRoute
  '/home/youtube': typeof appHomeYoutubeRoute
  '/school-classes/$id': typeof appSchoolClassesIdRoute
  '/settings/integrations': typeof appSettingsIntegrationsRoute
  '/support/contact': typeof appSupportContactRoute
  '/support/installation': typeof appSupportInstallationRoute
  '/oauth/fortnox/callback': typeof OauthFortnoxCallbackRoute
  '/oauth/github/callback': typeof OauthGithubCallbackRoute
  '/oauth/pipedrive/callback': typeof OauthPipedriveCallbackRoute
  '/admin/': typeof appAdminIndexRoute
  '/courses/': typeof appCoursesIndexRoute
  '/groups': typeof appGroupsIndexRoute
  '/home/': typeof appHomeIndexRoute
  '/school-classes': typeof appSchoolClassesIndexRoute
  '/support': typeof appSupportIndexRoute
  '/users': typeof appUsersIndexRoute
  '/groups/$id/edit': typeof fullscreenGroupsIdEditRouteRouteWithChildren
  '/users/$id/edit': typeof fullscreenUsersIdEditRouteRouteWithChildren
  '/admin/academy/courses': typeof appAdminAcademyCoursesRoute
  '/admin/bug/$bugId': typeof appAdminBugBugIdRoute
  '/admin/competitions/$id': typeof appAdminCompetitionsIdRouteWithChildren
  '/admin/competitions/create': typeof appAdminCompetitionsCreateRoute
  '/admin/tickets/bugreport': typeof appAdminTicketsBugreportRoute
  '/admin/tickets/feedback': typeof appAdminTicketsFeedbackRoute
  '/groups/$id/courses': typeof appGroupsIdCoursesRoute
  '/groups/$id/driving-history': typeof appGroupsIdDrivingHistoryRoute
  '/groups/$id/tachograph': typeof appGroupsIdTachographRoute
  '/users/$id/courses': typeof appUsersIdCoursesRoute
  '/users/$id/driving-record': typeof appUsersIdDrivingRecordRoute
  '/users/$id/profile': typeof appUsersIdProfileRoute
  '/users/$id/tachograph': typeof appUsersIdTachographRoute
  '/users/create/import': typeof appUsersCreateImportRoute
  '/users/create/new': typeof appUsersCreateNewRoute
  '/admin/academy/': typeof appAdminAcademyIndexRoute
  '/admin/competitions': typeof appAdminCompetitionsIndexRoute
  '/admin/framerates': typeof appAdminFrameratesIndexRoute
  '/admin/organizations/': typeof appAdminOrganizationsIndexRoute
  '/admin/tickets/': typeof appAdminTicketsIndexRoute
  '/courses/$type': typeof appCoursesTypeIndexRoute
  '/groups/$id/': typeof appGroupsIdIndexRoute
  '/home/academy': typeof appHomeAcademyIndexRoute
  '/users/$id/': typeof appUsersIdIndexRoute
  '/users/create/': typeof appUsersCreateIndexRoute
  '/admin/competitions/$id/edit': typeof appAdminCompetitionsIdEditRoute
  '/groups/$id/edit/courses': typeof fullscreenGroupsIdEditCoursesRoute
  '/groups/$id/edit/settings': typeof fullscreenGroupsIdEditSettingsRoute
  '/groups/$id/edit/users': typeof fullscreenGroupsIdEditUsersRoute
  '/home/academy/$lectureId/$segmentId': typeof fullscreenHomeAcademyLectureIdSegmentIdRoute
  '/users/$id/edit/account': typeof fullscreenUsersIdEditAccountRoute
  '/users/$id/edit/courses': typeof fullscreenUsersIdEditCoursesRoute
  '/users/$id/edit/personal-info': typeof fullscreenUsersIdEditPersonalInfoRoute
  '/admin/academy/stats': typeof appAdminAcademyStatsIndexRoute
  '/admin/competitions/$id/': typeof appAdminCompetitionsIdIndexRoute
  '/admin/organizations/$organizationId': typeof appAdminOrganizationsOrganizationIdIndexRoute
  '/admin/tickets/$id': typeof appAdminTicketsIdIndexRoute
  '/courses/$type/$publicCourseUuid': typeof appCoursesTypePublicCourseUuidIndexRoute
  '/admin/academy/stats/$lectureId/$schoolId': typeof appAdminAcademyStatsLectureIdSchoolIdRoute
  '/admin/organizations/$organizationId/schools/$schoolId': typeof appAdminOrganizationsOrganizationIdSchoolsSchoolIdRoute
  '/courses/$type/$publicCourseUuid/lessons/$publicLessonUuid': typeof appCoursesTypePublicCourseUuidLessonsPublicLessonUuidRoute
  '/admin/tickets/$id/screenshot/$bugId': typeof fullscreenAdminTicketsIdScreenshotBugIdRoute
  '/admin/academy/stats/$lectureId': typeof appAdminAcademyStatsLectureIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activate': typeof ActivateRoute
  '/login': typeof LoginRoute
  '/about': typeof appAboutRoute
  '/academy': typeof appAcademyRoute
  '/simulators': typeof appSimulatorsRoute
  '/welcome': typeof fullscreenWelcomeRoute
  '/course-editor/$publicUuid': typeof CourseEditorPublicUuidRoute
  '/admin/billing': typeof appAdminBillingRoute
  '/admin/client-distribution': typeof appAdminClientDistributionRoute
  '/admin/clients': typeof appAdminClientsRoute
  '/admin/course-editor-stats': typeof appAdminCourseEditorStatsRoute
  '/admin/exercise-leaderboard': typeof appAdminExerciseLeaderboardRoute
  '/admin/export-comments': typeof appAdminExportCommentsRoute
  '/admin/license-updates': typeof appAdminLicenseUpdatesRoute
  '/admin/map': typeof appAdminMapRoute
  '/admin/partners': typeof appAdminPartnersRoute
  '/admin/rundata': typeof appAdminRundataRoute
  '/admin/schools': typeof appAdminSchoolsRoute
  '/admin/simulator-fleet': typeof appAdminSimulatorFleetRoute
  '/admin/simulators': typeof appAdminSimulatorsRoute
  '/admin/stats': typeof appAdminStatsRoute
  '/admin/toplist': typeof appAdminToplistRoute
  '/admin/users': typeof appAdminUsersRoute
  '/groups/create': typeof appGroupsCreateRoute
  '/home/news': typeof appHomeNewsRoute
  '/home/start': typeof appHomeStartRoute
  '/home/stats': typeof appHomeStatsRoute
  '/home/youtube': typeof appHomeYoutubeRoute
  '/school-classes/$id': typeof appSchoolClassesIdRoute
  '/settings/integrations': typeof appSettingsIntegrationsRoute
  '/support/contact': typeof appSupportContactRoute
  '/support/installation': typeof appSupportInstallationRoute
  '/oauth/fortnox/callback': typeof OauthFortnoxCallbackRoute
  '/oauth/github/callback': typeof OauthGithubCallbackRoute
  '/oauth/pipedrive/callback': typeof OauthPipedriveCallbackRoute
  '/admin': typeof appAdminIndexRoute
  '/courses': typeof appCoursesIndexRoute
  '/groups': typeof appGroupsIndexRoute
  '/home': typeof appHomeIndexRoute
  '/school-classes': typeof appSchoolClassesIndexRoute
  '/support': typeof appSupportIndexRoute
  '/users': typeof appUsersIndexRoute
  '/groups/$id/edit': typeof fullscreenGroupsIdEditRouteRouteWithChildren
  '/users/$id/edit': typeof fullscreenUsersIdEditRouteRouteWithChildren
  '/admin/academy/courses': typeof appAdminAcademyCoursesRoute
  '/admin/bug/$bugId': typeof appAdminBugBugIdRoute
  '/admin/competitions/create': typeof appAdminCompetitionsCreateRoute
  '/admin/tickets/bugreport': typeof appAdminTicketsBugreportRoute
  '/admin/tickets/feedback': typeof appAdminTicketsFeedbackRoute
  '/groups/$id/courses': typeof appGroupsIdCoursesRoute
  '/groups/$id/driving-history': typeof appGroupsIdDrivingHistoryRoute
  '/groups/$id/tachograph': typeof appGroupsIdTachographRoute
  '/users/$id/courses': typeof appUsersIdCoursesRoute
  '/users/$id/driving-record': typeof appUsersIdDrivingRecordRoute
  '/users/$id/profile': typeof appUsersIdProfileRoute
  '/users/$id/tachograph': typeof appUsersIdTachographRoute
  '/users/create/import': typeof appUsersCreateImportRoute
  '/users/create/new': typeof appUsersCreateNewRoute
  '/admin/academy': typeof appAdminAcademyIndexRoute
  '/admin/competitions': typeof appAdminCompetitionsIndexRoute
  '/admin/framerates': typeof appAdminFrameratesIndexRoute
  '/admin/organizations': typeof appAdminOrganizationsIndexRoute
  '/admin/tickets': typeof appAdminTicketsIndexRoute
  '/courses/$type': typeof appCoursesTypeIndexRoute
  '/groups/$id': typeof appGroupsIdIndexRoute
  '/home/academy': typeof appHomeAcademyIndexRoute
  '/users/$id': typeof appUsersIdIndexRoute
  '/users/create': typeof appUsersCreateIndexRoute
  '/admin/competitions/$id/edit': typeof appAdminCompetitionsIdEditRoute
  '/groups/$id/edit/courses': typeof fullscreenGroupsIdEditCoursesRoute
  '/groups/$id/edit/settings': typeof fullscreenGroupsIdEditSettingsRoute
  '/groups/$id/edit/users': typeof fullscreenGroupsIdEditUsersRoute
  '/home/academy/$lectureId/$segmentId': typeof fullscreenHomeAcademyLectureIdSegmentIdRoute
  '/users/$id/edit/account': typeof fullscreenUsersIdEditAccountRoute
  '/users/$id/edit/courses': typeof fullscreenUsersIdEditCoursesRoute
  '/users/$id/edit/personal-info': typeof fullscreenUsersIdEditPersonalInfoRoute
  '/admin/academy/stats': typeof appAdminAcademyStatsIndexRoute
  '/admin/competitions/$id': typeof appAdminCompetitionsIdIndexRoute
  '/admin/organizations/$organizationId': typeof appAdminOrganizationsOrganizationIdIndexRoute
  '/admin/tickets/$id': typeof appAdminTicketsIdIndexRoute
  '/courses/$type/$publicCourseUuid': typeof appCoursesTypePublicCourseUuidIndexRoute
  '/admin/academy/stats/$lectureId/$schoolId': typeof appAdminAcademyStatsLectureIdSchoolIdRoute
  '/admin/organizations/$organizationId/schools/$schoolId': typeof appAdminOrganizationsOrganizationIdSchoolsSchoolIdRoute
  '/courses/$type/$publicCourseUuid/lessons/$publicLessonUuid': typeof appCoursesTypePublicCourseUuidLessonsPublicLessonUuidRoute
  '/admin/tickets/$id/screenshot/$bugId': typeof fullscreenAdminTicketsIdScreenshotBugIdRoute
  '/admin/academy/stats/$lectureId': typeof appAdminAcademyStatsLectureIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(app)': typeof appRouteRouteWithChildren
  '/(fullscreen)': typeof fullscreenRouteRouteWithChildren
  '/activate': typeof ActivateRoute
  '/login': typeof LoginRoute
  '/(app)/admin': typeof appAdminRouteRouteWithChildren
  '/(app)/courses': typeof appCoursesRouteRouteWithChildren
  '/(app)/home': typeof appHomeRouteRouteWithChildren
  '/(app)/about': typeof appAboutRoute
  '/(app)/academy': typeof appAcademyRoute
  '/(app)/simulators': typeof appSimulatorsRoute
  '/(fullscreen)/welcome': typeof fullscreenWelcomeRoute
  '/course-editor/$publicUuid': typeof CourseEditorPublicUuidRoute
  '/(app)/admin/academy': typeof appAdminAcademyRouteRouteWithChildren
  '/(app)/admin/tickets': typeof appAdminTicketsRouteRouteWithChildren
  '/(app)/groups/$id': typeof appGroupsIdRouteRouteWithChildren
  '/(app)/users/$id': typeof appUsersIdRouteRouteWithChildren
  '/(app)/users/create': typeof appUsersCreateRouteRouteWithChildren
  '/(app)/admin/billing': typeof appAdminBillingRoute
  '/(app)/admin/client-distribution': typeof appAdminClientDistributionRoute
  '/(app)/admin/clients': typeof appAdminClientsRoute
  '/(app)/admin/course-editor-stats': typeof appAdminCourseEditorStatsRoute
  '/(app)/admin/exercise-leaderboard': typeof appAdminExerciseLeaderboardRoute
  '/(app)/admin/export-comments': typeof appAdminExportCommentsRoute
  '/(app)/admin/license-updates': typeof appAdminLicenseUpdatesRoute
  '/(app)/admin/map': typeof appAdminMapRoute
  '/(app)/admin/organizations': typeof appAdminOrganizationsRouteWithChildren
  '/(app)/admin/partners': typeof appAdminPartnersRoute
  '/(app)/admin/rundata': typeof appAdminRundataRoute
  '/(app)/admin/schools': typeof appAdminSchoolsRoute
  '/(app)/admin/simulator-fleet': typeof appAdminSimulatorFleetRoute
  '/(app)/admin/simulators': typeof appAdminSimulatorsRoute
  '/(app)/admin/stats': typeof appAdminStatsRoute
  '/(app)/admin/toplist': typeof appAdminToplistRoute
  '/(app)/admin/users': typeof appAdminUsersRoute
  '/(app)/groups/create': typeof appGroupsCreateRoute
  '/(app)/home/news': typeof appHomeNewsRoute
  '/(app)/home/start': typeof appHomeStartRoute
  '/(app)/home/stats': typeof appHomeStatsRoute
  '/(app)/home/youtube': typeof appHomeYoutubeRoute
  '/(app)/school-classes/$id': typeof appSchoolClassesIdRoute
  '/(app)/settings/integrations': typeof appSettingsIntegrationsRoute
  '/(app)/support/contact': typeof appSupportContactRoute
  '/(app)/support/installation': typeof appSupportInstallationRoute
  '/oauth/fortnox/callback': typeof OauthFortnoxCallbackRoute
  '/oauth/github/callback': typeof OauthGithubCallbackRoute
  '/oauth/pipedrive/callback': typeof OauthPipedriveCallbackRoute
  '/(app)/admin/': typeof appAdminIndexRoute
  '/(app)/courses/': typeof appCoursesIndexRoute
  '/(app)/groups/': typeof appGroupsIndexRoute
  '/(app)/home/': typeof appHomeIndexRoute
  '/(app)/school-classes/': typeof appSchoolClassesIndexRoute
  '/(app)/support/': typeof appSupportIndexRoute
  '/(app)/users/': typeof appUsersIndexRoute
  '/(fullscreen)/groups/$id/edit': typeof fullscreenGroupsIdEditRouteRouteWithChildren
  '/(fullscreen)/users/$id/edit': typeof fullscreenUsersIdEditRouteRouteWithChildren
  '/(app)/admin/academy/courses': typeof appAdminAcademyCoursesRoute
  '/(app)/admin/bug/$bugId': typeof appAdminBugBugIdRoute
  '/(app)/admin/competitions/$id': typeof appAdminCompetitionsIdRouteWithChildren
  '/(app)/admin/competitions/create': typeof appAdminCompetitionsCreateRoute
  '/(app)/admin/tickets/bugreport': typeof appAdminTicketsBugreportRoute
  '/(app)/admin/tickets/feedback': typeof appAdminTicketsFeedbackRoute
  '/(app)/groups/$id/courses': typeof appGroupsIdCoursesRoute
  '/(app)/groups/$id/driving-history': typeof appGroupsIdDrivingHistoryRoute
  '/(app)/groups/$id/tachograph': typeof appGroupsIdTachographRoute
  '/(app)/users/$id/courses': typeof appUsersIdCoursesRoute
  '/(app)/users/$id/driving-record': typeof appUsersIdDrivingRecordRoute
  '/(app)/users/$id/profile': typeof appUsersIdProfileRoute
  '/(app)/users/$id/tachograph': typeof appUsersIdTachographRoute
  '/(app)/users/create/import': typeof appUsersCreateImportRoute
  '/(app)/users/create/new': typeof appUsersCreateNewRoute
  '/(app)/admin/academy/': typeof appAdminAcademyIndexRoute
  '/(app)/admin/competitions/': typeof appAdminCompetitionsIndexRoute
  '/(app)/admin/framerates/': typeof appAdminFrameratesIndexRoute
  '/(app)/admin/organizations/': typeof appAdminOrganizationsIndexRoute
  '/(app)/admin/tickets/': typeof appAdminTicketsIndexRoute
  '/(app)/courses/$type/': typeof appCoursesTypeIndexRoute
  '/(app)/groups/$id/': typeof appGroupsIdIndexRoute
  '/(app)/home/academy/': typeof appHomeAcademyIndexRoute
  '/(app)/users/$id/': typeof appUsersIdIndexRoute
  '/(app)/users/create/': typeof appUsersCreateIndexRoute
  '/(app)/admin/competitions/$id/edit': typeof appAdminCompetitionsIdEditRoute
  '/(fullscreen)/groups/$id/edit/courses': typeof fullscreenGroupsIdEditCoursesRoute
  '/(fullscreen)/groups/$id/edit/settings': typeof fullscreenGroupsIdEditSettingsRoute
  '/(fullscreen)/groups/$id/edit/users': typeof fullscreenGroupsIdEditUsersRoute
  '/(fullscreen)/home/academy/$lectureId/$segmentId': typeof fullscreenHomeAcademyLectureIdSegmentIdRoute
  '/(fullscreen)/users/$id/edit/account': typeof fullscreenUsersIdEditAccountRoute
  '/(fullscreen)/users/$id/edit/courses': typeof fullscreenUsersIdEditCoursesRoute
  '/(fullscreen)/users/$id/edit/personal-info': typeof fullscreenUsersIdEditPersonalInfoRoute
  '/(app)/admin/academy/stats/': typeof appAdminAcademyStatsIndexRoute
  '/(app)/admin/competitions/$id/': typeof appAdminCompetitionsIdIndexRoute
  '/(app)/admin/organizations/$organizationId/': typeof appAdminOrganizationsOrganizationIdIndexRoute
  '/(app)/admin/tickets/$id/': typeof appAdminTicketsIdIndexRoute
  '/(app)/courses_/$type/$publicCourseUuid/': typeof appCoursesTypePublicCourseUuidIndexRoute
  '/(app)/admin/academy/stats/$lectureId/$schoolId': typeof appAdminAcademyStatsLectureIdSchoolIdRoute
  '/(app)/admin/organizations/$organizationId/schools/$schoolId': typeof appAdminOrganizationsOrganizationIdSchoolsSchoolIdRoute
  '/(app)/courses_/$type/$publicCourseUuid/lessons/$publicLessonUuid': typeof appCoursesTypePublicCourseUuidLessonsPublicLessonUuidRoute
  '/(fullscreen)/admin/tickets/$id/screenshot/$bugId': typeof fullscreenAdminTicketsIdScreenshotBugIdRoute
  '/(app)/admin/academy/stats/$lectureId/': typeof appAdminAcademyStatsLectureIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate'
    | '/login'
    | '/admin'
    | '/courses'
    | '/home'
    | '/about'
    | '/academy'
    | '/simulators'
    | '/welcome'
    | '/course-editor/$publicUuid'
    | '/admin/academy'
    | '/admin/tickets'
    | '/groups/$id'
    | '/users/$id'
    | '/users/create'
    | '/admin/billing'
    | '/admin/client-distribution'
    | '/admin/clients'
    | '/admin/course-editor-stats'
    | '/admin/exercise-leaderboard'
    | '/admin/export-comments'
    | '/admin/license-updates'
    | '/admin/map'
    | '/admin/organizations'
    | '/admin/partners'
    | '/admin/rundata'
    | '/admin/schools'
    | '/admin/simulator-fleet'
    | '/admin/simulators'
    | '/admin/stats'
    | '/admin/toplist'
    | '/admin/users'
    | '/groups/create'
    | '/home/news'
    | '/home/start'
    | '/home/stats'
    | '/home/youtube'
    | '/school-classes/$id'
    | '/settings/integrations'
    | '/support/contact'
    | '/support/installation'
    | '/oauth/fortnox/callback'
    | '/oauth/github/callback'
    | '/oauth/pipedrive/callback'
    | '/admin/'
    | '/courses/'
    | '/groups'
    | '/home/'
    | '/school-classes'
    | '/support'
    | '/users'
    | '/groups/$id/edit'
    | '/users/$id/edit'
    | '/admin/academy/courses'
    | '/admin/bug/$bugId'
    | '/admin/competitions/$id'
    | '/admin/competitions/create'
    | '/admin/tickets/bugreport'
    | '/admin/tickets/feedback'
    | '/groups/$id/courses'
    | '/groups/$id/driving-history'
    | '/groups/$id/tachograph'
    | '/users/$id/courses'
    | '/users/$id/driving-record'
    | '/users/$id/profile'
    | '/users/$id/tachograph'
    | '/users/create/import'
    | '/users/create/new'
    | '/admin/academy/'
    | '/admin/competitions'
    | '/admin/framerates'
    | '/admin/organizations/'
    | '/admin/tickets/'
    | '/courses/$type'
    | '/groups/$id/'
    | '/home/academy'
    | '/users/$id/'
    | '/users/create/'
    | '/admin/competitions/$id/edit'
    | '/groups/$id/edit/courses'
    | '/groups/$id/edit/settings'
    | '/groups/$id/edit/users'
    | '/home/academy/$lectureId/$segmentId'
    | '/users/$id/edit/account'
    | '/users/$id/edit/courses'
    | '/users/$id/edit/personal-info'
    | '/admin/academy/stats'
    | '/admin/competitions/$id/'
    | '/admin/organizations/$organizationId'
    | '/admin/tickets/$id'
    | '/courses/$type/$publicCourseUuid'
    | '/admin/academy/stats/$lectureId/$schoolId'
    | '/admin/organizations/$organizationId/schools/$schoolId'
    | '/courses/$type/$publicCourseUuid/lessons/$publicLessonUuid'
    | '/admin/tickets/$id/screenshot/$bugId'
    | '/admin/academy/stats/$lectureId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activate'
    | '/login'
    | '/about'
    | '/academy'
    | '/simulators'
    | '/welcome'
    | '/course-editor/$publicUuid'
    | '/admin/billing'
    | '/admin/client-distribution'
    | '/admin/clients'
    | '/admin/course-editor-stats'
    | '/admin/exercise-leaderboard'
    | '/admin/export-comments'
    | '/admin/license-updates'
    | '/admin/map'
    | '/admin/partners'
    | '/admin/rundata'
    | '/admin/schools'
    | '/admin/simulator-fleet'
    | '/admin/simulators'
    | '/admin/stats'
    | '/admin/toplist'
    | '/admin/users'
    | '/groups/create'
    | '/home/news'
    | '/home/start'
    | '/home/stats'
    | '/home/youtube'
    | '/school-classes/$id'
    | '/settings/integrations'
    | '/support/contact'
    | '/support/installation'
    | '/oauth/fortnox/callback'
    | '/oauth/github/callback'
    | '/oauth/pipedrive/callback'
    | '/admin'
    | '/courses'
    | '/groups'
    | '/home'
    | '/school-classes'
    | '/support'
    | '/users'
    | '/groups/$id/edit'
    | '/users/$id/edit'
    | '/admin/academy/courses'
    | '/admin/bug/$bugId'
    | '/admin/competitions/create'
    | '/admin/tickets/bugreport'
    | '/admin/tickets/feedback'
    | '/groups/$id/courses'
    | '/groups/$id/driving-history'
    | '/groups/$id/tachograph'
    | '/users/$id/courses'
    | '/users/$id/driving-record'
    | '/users/$id/profile'
    | '/users/$id/tachograph'
    | '/users/create/import'
    | '/users/create/new'
    | '/admin/academy'
    | '/admin/competitions'
    | '/admin/framerates'
    | '/admin/organizations'
    | '/admin/tickets'
    | '/courses/$type'
    | '/groups/$id'
    | '/home/academy'
    | '/users/$id'
    | '/users/create'
    | '/admin/competitions/$id/edit'
    | '/groups/$id/edit/courses'
    | '/groups/$id/edit/settings'
    | '/groups/$id/edit/users'
    | '/home/academy/$lectureId/$segmentId'
    | '/users/$id/edit/account'
    | '/users/$id/edit/courses'
    | '/users/$id/edit/personal-info'
    | '/admin/academy/stats'
    | '/admin/competitions/$id'
    | '/admin/organizations/$organizationId'
    | '/admin/tickets/$id'
    | '/courses/$type/$publicCourseUuid'
    | '/admin/academy/stats/$lectureId/$schoolId'
    | '/admin/organizations/$organizationId/schools/$schoolId'
    | '/courses/$type/$publicCourseUuid/lessons/$publicLessonUuid'
    | '/admin/tickets/$id/screenshot/$bugId'
    | '/admin/academy/stats/$lectureId'
  id:
    | '__root__'
    | '/'
    | '/(app)'
    | '/(fullscreen)'
    | '/activate'
    | '/login'
    | '/(app)/admin'
    | '/(app)/courses'
    | '/(app)/home'
    | '/(app)/about'
    | '/(app)/academy'
    | '/(app)/simulators'
    | '/(fullscreen)/welcome'
    | '/course-editor/$publicUuid'
    | '/(app)/admin/academy'
    | '/(app)/admin/tickets'
    | '/(app)/groups/$id'
    | '/(app)/users/$id'
    | '/(app)/users/create'
    | '/(app)/admin/billing'
    | '/(app)/admin/client-distribution'
    | '/(app)/admin/clients'
    | '/(app)/admin/course-editor-stats'
    | '/(app)/admin/exercise-leaderboard'
    | '/(app)/admin/export-comments'
    | '/(app)/admin/license-updates'
    | '/(app)/admin/map'
    | '/(app)/admin/organizations'
    | '/(app)/admin/partners'
    | '/(app)/admin/rundata'
    | '/(app)/admin/schools'
    | '/(app)/admin/simulator-fleet'
    | '/(app)/admin/simulators'
    | '/(app)/admin/stats'
    | '/(app)/admin/toplist'
    | '/(app)/admin/users'
    | '/(app)/groups/create'
    | '/(app)/home/news'
    | '/(app)/home/start'
    | '/(app)/home/stats'
    | '/(app)/home/youtube'
    | '/(app)/school-classes/$id'
    | '/(app)/settings/integrations'
    | '/(app)/support/contact'
    | '/(app)/support/installation'
    | '/oauth/fortnox/callback'
    | '/oauth/github/callback'
    | '/oauth/pipedrive/callback'
    | '/(app)/admin/'
    | '/(app)/courses/'
    | '/(app)/groups/'
    | '/(app)/home/'
    | '/(app)/school-classes/'
    | '/(app)/support/'
    | '/(app)/users/'
    | '/(fullscreen)/groups/$id/edit'
    | '/(fullscreen)/users/$id/edit'
    | '/(app)/admin/academy/courses'
    | '/(app)/admin/bug/$bugId'
    | '/(app)/admin/competitions/$id'
    | '/(app)/admin/competitions/create'
    | '/(app)/admin/tickets/bugreport'
    | '/(app)/admin/tickets/feedback'
    | '/(app)/groups/$id/courses'
    | '/(app)/groups/$id/driving-history'
    | '/(app)/groups/$id/tachograph'
    | '/(app)/users/$id/courses'
    | '/(app)/users/$id/driving-record'
    | '/(app)/users/$id/profile'
    | '/(app)/users/$id/tachograph'
    | '/(app)/users/create/import'
    | '/(app)/users/create/new'
    | '/(app)/admin/academy/'
    | '/(app)/admin/competitions/'
    | '/(app)/admin/framerates/'
    | '/(app)/admin/organizations/'
    | '/(app)/admin/tickets/'
    | '/(app)/courses/$type/'
    | '/(app)/groups/$id/'
    | '/(app)/home/academy/'
    | '/(app)/users/$id/'
    | '/(app)/users/create/'
    | '/(app)/admin/competitions/$id/edit'
    | '/(fullscreen)/groups/$id/edit/courses'
    | '/(fullscreen)/groups/$id/edit/settings'
    | '/(fullscreen)/groups/$id/edit/users'
    | '/(fullscreen)/home/academy/$lectureId/$segmentId'
    | '/(fullscreen)/users/$id/edit/account'
    | '/(fullscreen)/users/$id/edit/courses'
    | '/(fullscreen)/users/$id/edit/personal-info'
    | '/(app)/admin/academy/stats/'
    | '/(app)/admin/competitions/$id/'
    | '/(app)/admin/organizations/$organizationId/'
    | '/(app)/admin/tickets/$id/'
    | '/(app)/courses_/$type/$publicCourseUuid/'
    | '/(app)/admin/academy/stats/$lectureId/$schoolId'
    | '/(app)/admin/organizations/$organizationId/schools/$schoolId'
    | '/(app)/courses_/$type/$publicCourseUuid/lessons/$publicLessonUuid'
    | '/(fullscreen)/admin/tickets/$id/screenshot/$bugId'
    | '/(app)/admin/academy/stats/$lectureId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  appRouteRoute: typeof appRouteRouteWithChildren
  fullscreenRouteRoute: typeof fullscreenRouteRouteWithChildren
  ActivateRoute: typeof ActivateRoute
  LoginRoute: typeof LoginRoute
  CourseEditorPublicUuidRoute: typeof CourseEditorPublicUuidRoute
  OauthFortnoxCallbackRoute: typeof OauthFortnoxCallbackRoute
  OauthGithubCallbackRoute: typeof OauthGithubCallbackRoute
  OauthPipedriveCallbackRoute: typeof OauthPipedriveCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(fullscreen)': {
      id: '/(fullscreen)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof fullscreenRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)': {
      id: '/(app)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof appRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/course-editor/$publicUuid': {
      id: '/course-editor/$publicUuid'
      path: '/course-editor/$publicUuid'
      fullPath: '/course-editor/$publicUuid'
      preLoaderRoute: typeof CourseEditorPublicUuidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(fullscreen)/welcome': {
      id: '/(fullscreen)/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof fullscreenWelcomeRouteImport
      parentRoute: typeof fullscreenRouteRoute
    }
    '/(app)/simulators': {
      id: '/(app)/simulators'
      path: '/simulators'
      fullPath: '/simulators'
      preLoaderRoute: typeof appSimulatorsRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/academy': {
      id: '/(app)/academy'
      path: '/academy'
      fullPath: '/academy'
      preLoaderRoute: typeof appAcademyRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/about': {
      id: '/(app)/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof appAboutRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/home': {
      id: '/(app)/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof appHomeRouteRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/courses': {
      id: '/(app)/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof appCoursesRouteRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/admin': {
      id: '/(app)/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof appAdminRouteRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/users/': {
      id: '/(app)/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof appUsersIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/support/': {
      id: '/(app)/support/'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof appSupportIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/school-classes/': {
      id: '/(app)/school-classes/'
      path: '/school-classes'
      fullPath: '/school-classes'
      preLoaderRoute: typeof appSchoolClassesIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/home/': {
      id: '/(app)/home/'
      path: '/'
      fullPath: '/home/'
      preLoaderRoute: typeof appHomeIndexRouteImport
      parentRoute: typeof appHomeRouteRoute
    }
    '/(app)/groups/': {
      id: '/(app)/groups/'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof appGroupsIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/courses/': {
      id: '/(app)/courses/'
      path: '/'
      fullPath: '/courses/'
      preLoaderRoute: typeof appCoursesIndexRouteImport
      parentRoute: typeof appCoursesRouteRoute
    }
    '/(app)/admin/': {
      id: '/(app)/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof appAdminIndexRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/oauth/pipedrive/callback': {
      id: '/oauth/pipedrive/callback'
      path: '/oauth/pipedrive/callback'
      fullPath: '/oauth/pipedrive/callback'
      preLoaderRoute: typeof OauthPipedriveCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/github/callback': {
      id: '/oauth/github/callback'
      path: '/oauth/github/callback'
      fullPath: '/oauth/github/callback'
      preLoaderRoute: typeof OauthGithubCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/fortnox/callback': {
      id: '/oauth/fortnox/callback'
      path: '/oauth/fortnox/callback'
      fullPath: '/oauth/fortnox/callback'
      preLoaderRoute: typeof OauthFortnoxCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/support/installation': {
      id: '/(app)/support/installation'
      path: '/support/installation'
      fullPath: '/support/installation'
      preLoaderRoute: typeof appSupportInstallationRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/support/contact': {
      id: '/(app)/support/contact'
      path: '/support/contact'
      fullPath: '/support/contact'
      preLoaderRoute: typeof appSupportContactRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/settings/integrations': {
      id: '/(app)/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof appSettingsIntegrationsRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/school-classes/$id': {
      id: '/(app)/school-classes/$id'
      path: '/school-classes/$id'
      fullPath: '/school-classes/$id'
      preLoaderRoute: typeof appSchoolClassesIdRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/home/youtube': {
      id: '/(app)/home/youtube'
      path: '/youtube'
      fullPath: '/home/youtube'
      preLoaderRoute: typeof appHomeYoutubeRouteImport
      parentRoute: typeof appHomeRouteRoute
    }
    '/(app)/home/stats': {
      id: '/(app)/home/stats'
      path: '/stats'
      fullPath: '/home/stats'
      preLoaderRoute: typeof appHomeStatsRouteImport
      parentRoute: typeof appHomeRouteRoute
    }
    '/(app)/home/start': {
      id: '/(app)/home/start'
      path: '/start'
      fullPath: '/home/start'
      preLoaderRoute: typeof appHomeStartRouteImport
      parentRoute: typeof appHomeRouteRoute
    }
    '/(app)/home/news': {
      id: '/(app)/home/news'
      path: '/news'
      fullPath: '/home/news'
      preLoaderRoute: typeof appHomeNewsRouteImport
      parentRoute: typeof appHomeRouteRoute
    }
    '/(app)/groups/create': {
      id: '/(app)/groups/create'
      path: '/groups/create'
      fullPath: '/groups/create'
      preLoaderRoute: typeof appGroupsCreateRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/admin/users': {
      id: '/(app)/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof appAdminUsersRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/toplist': {
      id: '/(app)/admin/toplist'
      path: '/toplist'
      fullPath: '/admin/toplist'
      preLoaderRoute: typeof appAdminToplistRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/stats': {
      id: '/(app)/admin/stats'
      path: '/stats'
      fullPath: '/admin/stats'
      preLoaderRoute: typeof appAdminStatsRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/simulators': {
      id: '/(app)/admin/simulators'
      path: '/simulators'
      fullPath: '/admin/simulators'
      preLoaderRoute: typeof appAdminSimulatorsRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/simulator-fleet': {
      id: '/(app)/admin/simulator-fleet'
      path: '/simulator-fleet'
      fullPath: '/admin/simulator-fleet'
      preLoaderRoute: typeof appAdminSimulatorFleetRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/schools': {
      id: '/(app)/admin/schools'
      path: '/schools'
      fullPath: '/admin/schools'
      preLoaderRoute: typeof appAdminSchoolsRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/rundata': {
      id: '/(app)/admin/rundata'
      path: '/rundata'
      fullPath: '/admin/rundata'
      preLoaderRoute: typeof appAdminRundataRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/partners': {
      id: '/(app)/admin/partners'
      path: '/partners'
      fullPath: '/admin/partners'
      preLoaderRoute: typeof appAdminPartnersRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/organizations': {
      id: '/(app)/admin/organizations'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof appAdminOrganizationsRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/map': {
      id: '/(app)/admin/map'
      path: '/map'
      fullPath: '/admin/map'
      preLoaderRoute: typeof appAdminMapRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/license-updates': {
      id: '/(app)/admin/license-updates'
      path: '/license-updates'
      fullPath: '/admin/license-updates'
      preLoaderRoute: typeof appAdminLicenseUpdatesRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/export-comments': {
      id: '/(app)/admin/export-comments'
      path: '/export-comments'
      fullPath: '/admin/export-comments'
      preLoaderRoute: typeof appAdminExportCommentsRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/exercise-leaderboard': {
      id: '/(app)/admin/exercise-leaderboard'
      path: '/exercise-leaderboard'
      fullPath: '/admin/exercise-leaderboard'
      preLoaderRoute: typeof appAdminExerciseLeaderboardRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/course-editor-stats': {
      id: '/(app)/admin/course-editor-stats'
      path: '/course-editor-stats'
      fullPath: '/admin/course-editor-stats'
      preLoaderRoute: typeof appAdminCourseEditorStatsRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/clients': {
      id: '/(app)/admin/clients'
      path: '/clients'
      fullPath: '/admin/clients'
      preLoaderRoute: typeof appAdminClientsRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/client-distribution': {
      id: '/(app)/admin/client-distribution'
      path: '/client-distribution'
      fullPath: '/admin/client-distribution'
      preLoaderRoute: typeof appAdminClientDistributionRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/billing': {
      id: '/(app)/admin/billing'
      path: '/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof appAdminBillingRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/users/create': {
      id: '/(app)/users/create'
      path: '/users/create'
      fullPath: '/users/create'
      preLoaderRoute: typeof appUsersCreateRouteRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/users/$id': {
      id: '/(app)/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof appUsersIdRouteRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/groups/$id': {
      id: '/(app)/groups/$id'
      path: '/groups/$id'
      fullPath: '/groups/$id'
      preLoaderRoute: typeof appGroupsIdRouteRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/admin/tickets': {
      id: '/(app)/admin/tickets'
      path: '/tickets'
      fullPath: '/admin/tickets'
      preLoaderRoute: typeof appAdminTicketsRouteRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/academy': {
      id: '/(app)/admin/academy'
      path: '/academy'
      fullPath: '/admin/academy'
      preLoaderRoute: typeof appAdminAcademyRouteRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/users/create/': {
      id: '/(app)/users/create/'
      path: '/'
      fullPath: '/users/create/'
      preLoaderRoute: typeof appUsersCreateIndexRouteImport
      parentRoute: typeof appUsersCreateRouteRoute
    }
    '/(app)/users/$id/': {
      id: '/(app)/users/$id/'
      path: '/'
      fullPath: '/users/$id/'
      preLoaderRoute: typeof appUsersIdIndexRouteImport
      parentRoute: typeof appUsersIdRouteRoute
    }
    '/(app)/home/academy/': {
      id: '/(app)/home/academy/'
      path: '/academy'
      fullPath: '/home/academy'
      preLoaderRoute: typeof appHomeAcademyIndexRouteImport
      parentRoute: typeof appHomeRouteRoute
    }
    '/(app)/groups/$id/': {
      id: '/(app)/groups/$id/'
      path: '/'
      fullPath: '/groups/$id/'
      preLoaderRoute: typeof appGroupsIdIndexRouteImport
      parentRoute: typeof appGroupsIdRouteRoute
    }
    '/(app)/courses/$type/': {
      id: '/(app)/courses/$type/'
      path: '/$type'
      fullPath: '/courses/$type'
      preLoaderRoute: typeof appCoursesTypeIndexRouteImport
      parentRoute: typeof appCoursesRouteRoute
    }
    '/(app)/admin/tickets/': {
      id: '/(app)/admin/tickets/'
      path: '/'
      fullPath: '/admin/tickets/'
      preLoaderRoute: typeof appAdminTicketsIndexRouteImport
      parentRoute: typeof appAdminTicketsRouteRoute
    }
    '/(app)/admin/organizations/': {
      id: '/(app)/admin/organizations/'
      path: '/'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof appAdminOrganizationsIndexRouteImport
      parentRoute: typeof appAdminOrganizationsRoute
    }
    '/(app)/admin/framerates/': {
      id: '/(app)/admin/framerates/'
      path: '/framerates'
      fullPath: '/admin/framerates'
      preLoaderRoute: typeof appAdminFrameratesIndexRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/competitions/': {
      id: '/(app)/admin/competitions/'
      path: '/competitions'
      fullPath: '/admin/competitions'
      preLoaderRoute: typeof appAdminCompetitionsIndexRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/academy/': {
      id: '/(app)/admin/academy/'
      path: '/'
      fullPath: '/admin/academy/'
      preLoaderRoute: typeof appAdminAcademyIndexRouteImport
      parentRoute: typeof appAdminAcademyRouteRoute
    }
    '/(app)/users/create/new': {
      id: '/(app)/users/create/new'
      path: '/new'
      fullPath: '/users/create/new'
      preLoaderRoute: typeof appUsersCreateNewRouteImport
      parentRoute: typeof appUsersCreateRouteRoute
    }
    '/(app)/users/create/import': {
      id: '/(app)/users/create/import'
      path: '/import'
      fullPath: '/users/create/import'
      preLoaderRoute: typeof appUsersCreateImportRouteImport
      parentRoute: typeof appUsersCreateRouteRoute
    }
    '/(app)/users/$id/tachograph': {
      id: '/(app)/users/$id/tachograph'
      path: '/tachograph'
      fullPath: '/users/$id/tachograph'
      preLoaderRoute: typeof appUsersIdTachographRouteImport
      parentRoute: typeof appUsersIdRouteRoute
    }
    '/(app)/users/$id/profile': {
      id: '/(app)/users/$id/profile'
      path: '/profile'
      fullPath: '/users/$id/profile'
      preLoaderRoute: typeof appUsersIdProfileRouteImport
      parentRoute: typeof appUsersIdRouteRoute
    }
    '/(app)/users/$id/driving-record': {
      id: '/(app)/users/$id/driving-record'
      path: '/driving-record'
      fullPath: '/users/$id/driving-record'
      preLoaderRoute: typeof appUsersIdDrivingRecordRouteImport
      parentRoute: typeof appUsersIdRouteRoute
    }
    '/(app)/users/$id/courses': {
      id: '/(app)/users/$id/courses'
      path: '/courses'
      fullPath: '/users/$id/courses'
      preLoaderRoute: typeof appUsersIdCoursesRouteImport
      parentRoute: typeof appUsersIdRouteRoute
    }
    '/(app)/groups/$id/tachograph': {
      id: '/(app)/groups/$id/tachograph'
      path: '/tachograph'
      fullPath: '/groups/$id/tachograph'
      preLoaderRoute: typeof appGroupsIdTachographRouteImport
      parentRoute: typeof appGroupsIdRouteRoute
    }
    '/(app)/groups/$id/driving-history': {
      id: '/(app)/groups/$id/driving-history'
      path: '/driving-history'
      fullPath: '/groups/$id/driving-history'
      preLoaderRoute: typeof appGroupsIdDrivingHistoryRouteImport
      parentRoute: typeof appGroupsIdRouteRoute
    }
    '/(app)/groups/$id/courses': {
      id: '/(app)/groups/$id/courses'
      path: '/courses'
      fullPath: '/groups/$id/courses'
      preLoaderRoute: typeof appGroupsIdCoursesRouteImport
      parentRoute: typeof appGroupsIdRouteRoute
    }
    '/(app)/admin/tickets/feedback': {
      id: '/(app)/admin/tickets/feedback'
      path: '/feedback'
      fullPath: '/admin/tickets/feedback'
      preLoaderRoute: typeof appAdminTicketsFeedbackRouteImport
      parentRoute: typeof appAdminTicketsRouteRoute
    }
    '/(app)/admin/tickets/bugreport': {
      id: '/(app)/admin/tickets/bugreport'
      path: '/bugreport'
      fullPath: '/admin/tickets/bugreport'
      preLoaderRoute: typeof appAdminTicketsBugreportRouteImport
      parentRoute: typeof appAdminTicketsRouteRoute
    }
    '/(app)/admin/competitions/create': {
      id: '/(app)/admin/competitions/create'
      path: '/competitions/create'
      fullPath: '/admin/competitions/create'
      preLoaderRoute: typeof appAdminCompetitionsCreateRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/competitions/$id': {
      id: '/(app)/admin/competitions/$id'
      path: '/competitions/$id'
      fullPath: '/admin/competitions/$id'
      preLoaderRoute: typeof appAdminCompetitionsIdRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/bug/$bugId': {
      id: '/(app)/admin/bug/$bugId'
      path: '/bug/$bugId'
      fullPath: '/admin/bug/$bugId'
      preLoaderRoute: typeof appAdminBugBugIdRouteImport
      parentRoute: typeof appAdminRouteRoute
    }
    '/(app)/admin/academy/courses': {
      id: '/(app)/admin/academy/courses'
      path: '/courses'
      fullPath: '/admin/academy/courses'
      preLoaderRoute: typeof appAdminAcademyCoursesRouteImport
      parentRoute: typeof appAdminAcademyRouteRoute
    }
    '/(fullscreen)/users/$id/edit': {
      id: '/(fullscreen)/users/$id/edit'
      path: '/users/$id/edit'
      fullPath: '/users/$id/edit'
      preLoaderRoute: typeof fullscreenUsersIdEditRouteRouteImport
      parentRoute: typeof fullscreenRouteRoute
    }
    '/(fullscreen)/groups/$id/edit': {
      id: '/(fullscreen)/groups/$id/edit'
      path: '/groups/$id/edit'
      fullPath: '/groups/$id/edit'
      preLoaderRoute: typeof fullscreenGroupsIdEditRouteRouteImport
      parentRoute: typeof fullscreenRouteRoute
    }
    '/(app)/courses_/$type/$publicCourseUuid/': {
      id: '/(app)/courses_/$type/$publicCourseUuid/'
      path: '/courses/$type/$publicCourseUuid'
      fullPath: '/courses/$type/$publicCourseUuid'
      preLoaderRoute: typeof appCoursesTypePublicCourseUuidIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/admin/tickets/$id/': {
      id: '/(app)/admin/tickets/$id/'
      path: '/$id'
      fullPath: '/admin/tickets/$id'
      preLoaderRoute: typeof appAdminTicketsIdIndexRouteImport
      parentRoute: typeof appAdminTicketsRouteRoute
    }
    '/(app)/admin/organizations/$organizationId/': {
      id: '/(app)/admin/organizations/$organizationId/'
      path: '/$organizationId'
      fullPath: '/admin/organizations/$organizationId'
      preLoaderRoute: typeof appAdminOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof appAdminOrganizationsRoute
    }
    '/(app)/admin/competitions/$id/': {
      id: '/(app)/admin/competitions/$id/'
      path: '/'
      fullPath: '/admin/competitions/$id/'
      preLoaderRoute: typeof appAdminCompetitionsIdIndexRouteImport
      parentRoute: typeof appAdminCompetitionsIdRoute
    }
    '/(app)/admin/academy/stats/': {
      id: '/(app)/admin/academy/stats/'
      path: '/stats'
      fullPath: '/admin/academy/stats'
      preLoaderRoute: typeof appAdminAcademyStatsIndexRouteImport
      parentRoute: typeof appAdminAcademyRouteRoute
    }
    '/(fullscreen)/users/$id/edit/personal-info': {
      id: '/(fullscreen)/users/$id/edit/personal-info'
      path: '/personal-info'
      fullPath: '/users/$id/edit/personal-info'
      preLoaderRoute: typeof fullscreenUsersIdEditPersonalInfoRouteImport
      parentRoute: typeof fullscreenUsersIdEditRouteRoute
    }
    '/(fullscreen)/users/$id/edit/courses': {
      id: '/(fullscreen)/users/$id/edit/courses'
      path: '/courses'
      fullPath: '/users/$id/edit/courses'
      preLoaderRoute: typeof fullscreenUsersIdEditCoursesRouteImport
      parentRoute: typeof fullscreenUsersIdEditRouteRoute
    }
    '/(fullscreen)/users/$id/edit/account': {
      id: '/(fullscreen)/users/$id/edit/account'
      path: '/account'
      fullPath: '/users/$id/edit/account'
      preLoaderRoute: typeof fullscreenUsersIdEditAccountRouteImport
      parentRoute: typeof fullscreenUsersIdEditRouteRoute
    }
    '/(fullscreen)/home/academy/$lectureId/$segmentId': {
      id: '/(fullscreen)/home/academy/$lectureId/$segmentId'
      path: '/home/academy/$lectureId/$segmentId'
      fullPath: '/home/academy/$lectureId/$segmentId'
      preLoaderRoute: typeof fullscreenHomeAcademyLectureIdSegmentIdRouteImport
      parentRoute: typeof fullscreenRouteRoute
    }
    '/(fullscreen)/groups/$id/edit/users': {
      id: '/(fullscreen)/groups/$id/edit/users'
      path: '/users'
      fullPath: '/groups/$id/edit/users'
      preLoaderRoute: typeof fullscreenGroupsIdEditUsersRouteImport
      parentRoute: typeof fullscreenGroupsIdEditRouteRoute
    }
    '/(fullscreen)/groups/$id/edit/settings': {
      id: '/(fullscreen)/groups/$id/edit/settings'
      path: '/settings'
      fullPath: '/groups/$id/edit/settings'
      preLoaderRoute: typeof fullscreenGroupsIdEditSettingsRouteImport
      parentRoute: typeof fullscreenGroupsIdEditRouteRoute
    }
    '/(fullscreen)/groups/$id/edit/courses': {
      id: '/(fullscreen)/groups/$id/edit/courses'
      path: '/courses'
      fullPath: '/groups/$id/edit/courses'
      preLoaderRoute: typeof fullscreenGroupsIdEditCoursesRouteImport
      parentRoute: typeof fullscreenGroupsIdEditRouteRoute
    }
    '/(app)/admin/competitions/$id/edit': {
      id: '/(app)/admin/competitions/$id/edit'
      path: '/edit'
      fullPath: '/admin/competitions/$id/edit'
      preLoaderRoute: typeof appAdminCompetitionsIdEditRouteImport
      parentRoute: typeof appAdminCompetitionsIdRoute
    }
    '/(app)/admin/academy/stats/$lectureId/': {
      id: '/(app)/admin/academy/stats/$lectureId/'
      path: '/stats/$lectureId'
      fullPath: '/admin/academy/stats/$lectureId'
      preLoaderRoute: typeof appAdminAcademyStatsLectureIdIndexRouteImport
      parentRoute: typeof appAdminAcademyRouteRoute
    }
    '/(fullscreen)/admin/tickets/$id/screenshot/$bugId': {
      id: '/(fullscreen)/admin/tickets/$id/screenshot/$bugId'
      path: '/admin/tickets/$id/screenshot/$bugId'
      fullPath: '/admin/tickets/$id/screenshot/$bugId'
      preLoaderRoute: typeof fullscreenAdminTicketsIdScreenshotBugIdRouteImport
      parentRoute: typeof fullscreenRouteRoute
    }
    '/(app)/courses_/$type/$publicCourseUuid/lessons/$publicLessonUuid': {
      id: '/(app)/courses_/$type/$publicCourseUuid/lessons/$publicLessonUuid'
      path: '/courses/$type/$publicCourseUuid/lessons/$publicLessonUuid'
      fullPath: '/courses/$type/$publicCourseUuid/lessons/$publicLessonUuid'
      preLoaderRoute: typeof appCoursesTypePublicCourseUuidLessonsPublicLessonUuidRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/admin/organizations/$organizationId/schools/$schoolId': {
      id: '/(app)/admin/organizations/$organizationId/schools/$schoolId'
      path: '/$organizationId/schools/$schoolId'
      fullPath: '/admin/organizations/$organizationId/schools/$schoolId'
      preLoaderRoute: typeof appAdminOrganizationsOrganizationIdSchoolsSchoolIdRouteImport
      parentRoute: typeof appAdminOrganizationsRoute
    }
    '/(app)/admin/academy/stats/$lectureId/$schoolId': {
      id: '/(app)/admin/academy/stats/$lectureId/$schoolId'
      path: '/stats/$lectureId/$schoolId'
      fullPath: '/admin/academy/stats/$lectureId/$schoolId'
      preLoaderRoute: typeof appAdminAcademyStatsLectureIdSchoolIdRouteImport
      parentRoute: typeof appAdminAcademyRouteRoute
    }
  }
}

interface appAdminAcademyRouteRouteChildren {
  appAdminAcademyCoursesRoute: typeof appAdminAcademyCoursesRoute
  appAdminAcademyIndexRoute: typeof appAdminAcademyIndexRoute
  appAdminAcademyStatsIndexRoute: typeof appAdminAcademyStatsIndexRoute
  appAdminAcademyStatsLectureIdSchoolIdRoute: typeof appAdminAcademyStatsLectureIdSchoolIdRoute
  appAdminAcademyStatsLectureIdIndexRoute: typeof appAdminAcademyStatsLectureIdIndexRoute
}

const appAdminAcademyRouteRouteChildren: appAdminAcademyRouteRouteChildren = {
  appAdminAcademyCoursesRoute: appAdminAcademyCoursesRoute,
  appAdminAcademyIndexRoute: appAdminAcademyIndexRoute,
  appAdminAcademyStatsIndexRoute: appAdminAcademyStatsIndexRoute,
  appAdminAcademyStatsLectureIdSchoolIdRoute:
    appAdminAcademyStatsLectureIdSchoolIdRoute,
  appAdminAcademyStatsLectureIdIndexRoute:
    appAdminAcademyStatsLectureIdIndexRoute,
}

const appAdminAcademyRouteRouteWithChildren =
  appAdminAcademyRouteRoute._addFileChildren(appAdminAcademyRouteRouteChildren)

interface appAdminTicketsRouteRouteChildren {
  appAdminTicketsBugreportRoute: typeof appAdminTicketsBugreportRoute
  appAdminTicketsFeedbackRoute: typeof appAdminTicketsFeedbackRoute
  appAdminTicketsIndexRoute: typeof appAdminTicketsIndexRoute
  appAdminTicketsIdIndexRoute: typeof appAdminTicketsIdIndexRoute
}

const appAdminTicketsRouteRouteChildren: appAdminTicketsRouteRouteChildren = {
  appAdminTicketsBugreportRoute: appAdminTicketsBugreportRoute,
  appAdminTicketsFeedbackRoute: appAdminTicketsFeedbackRoute,
  appAdminTicketsIndexRoute: appAdminTicketsIndexRoute,
  appAdminTicketsIdIndexRoute: appAdminTicketsIdIndexRoute,
}

const appAdminTicketsRouteRouteWithChildren =
  appAdminTicketsRouteRoute._addFileChildren(appAdminTicketsRouteRouteChildren)

interface appAdminOrganizationsRouteChildren {
  appAdminOrganizationsIndexRoute: typeof appAdminOrganizationsIndexRoute
  appAdminOrganizationsOrganizationIdIndexRoute: typeof appAdminOrganizationsOrganizationIdIndexRoute
  appAdminOrganizationsOrganizationIdSchoolsSchoolIdRoute: typeof appAdminOrganizationsOrganizationIdSchoolsSchoolIdRoute
}

const appAdminOrganizationsRouteChildren: appAdminOrganizationsRouteChildren = {
  appAdminOrganizationsIndexRoute: appAdminOrganizationsIndexRoute,
  appAdminOrganizationsOrganizationIdIndexRoute:
    appAdminOrganizationsOrganizationIdIndexRoute,
  appAdminOrganizationsOrganizationIdSchoolsSchoolIdRoute:
    appAdminOrganizationsOrganizationIdSchoolsSchoolIdRoute,
}

const appAdminOrganizationsRouteWithChildren =
  appAdminOrganizationsRoute._addFileChildren(
    appAdminOrganizationsRouteChildren,
  )

interface appAdminCompetitionsIdRouteChildren {
  appAdminCompetitionsIdEditRoute: typeof appAdminCompetitionsIdEditRoute
  appAdminCompetitionsIdIndexRoute: typeof appAdminCompetitionsIdIndexRoute
}

const appAdminCompetitionsIdRouteChildren: appAdminCompetitionsIdRouteChildren =
  {
    appAdminCompetitionsIdEditRoute: appAdminCompetitionsIdEditRoute,
    appAdminCompetitionsIdIndexRoute: appAdminCompetitionsIdIndexRoute,
  }

const appAdminCompetitionsIdRouteWithChildren =
  appAdminCompetitionsIdRoute._addFileChildren(
    appAdminCompetitionsIdRouteChildren,
  )

interface appAdminRouteRouteChildren {
  appAdminAcademyRouteRoute: typeof appAdminAcademyRouteRouteWithChildren
  appAdminTicketsRouteRoute: typeof appAdminTicketsRouteRouteWithChildren
  appAdminBillingRoute: typeof appAdminBillingRoute
  appAdminClientDistributionRoute: typeof appAdminClientDistributionRoute
  appAdminClientsRoute: typeof appAdminClientsRoute
  appAdminCourseEditorStatsRoute: typeof appAdminCourseEditorStatsRoute
  appAdminExerciseLeaderboardRoute: typeof appAdminExerciseLeaderboardRoute
  appAdminExportCommentsRoute: typeof appAdminExportCommentsRoute
  appAdminLicenseUpdatesRoute: typeof appAdminLicenseUpdatesRoute
  appAdminMapRoute: typeof appAdminMapRoute
  appAdminOrganizationsRoute: typeof appAdminOrganizationsRouteWithChildren
  appAdminPartnersRoute: typeof appAdminPartnersRoute
  appAdminRundataRoute: typeof appAdminRundataRoute
  appAdminSchoolsRoute: typeof appAdminSchoolsRoute
  appAdminSimulatorFleetRoute: typeof appAdminSimulatorFleetRoute
  appAdminSimulatorsRoute: typeof appAdminSimulatorsRoute
  appAdminStatsRoute: typeof appAdminStatsRoute
  appAdminToplistRoute: typeof appAdminToplistRoute
  appAdminUsersRoute: typeof appAdminUsersRoute
  appAdminIndexRoute: typeof appAdminIndexRoute
  appAdminBugBugIdRoute: typeof appAdminBugBugIdRoute
  appAdminCompetitionsIdRoute: typeof appAdminCompetitionsIdRouteWithChildren
  appAdminCompetitionsCreateRoute: typeof appAdminCompetitionsCreateRoute
  appAdminCompetitionsIndexRoute: typeof appAdminCompetitionsIndexRoute
  appAdminFrameratesIndexRoute: typeof appAdminFrameratesIndexRoute
}

const appAdminRouteRouteChildren: appAdminRouteRouteChildren = {
  appAdminAcademyRouteRoute: appAdminAcademyRouteRouteWithChildren,
  appAdminTicketsRouteRoute: appAdminTicketsRouteRouteWithChildren,
  appAdminBillingRoute: appAdminBillingRoute,
  appAdminClientDistributionRoute: appAdminClientDistributionRoute,
  appAdminClientsRoute: appAdminClientsRoute,
  appAdminCourseEditorStatsRoute: appAdminCourseEditorStatsRoute,
  appAdminExerciseLeaderboardRoute: appAdminExerciseLeaderboardRoute,
  appAdminExportCommentsRoute: appAdminExportCommentsRoute,
  appAdminLicenseUpdatesRoute: appAdminLicenseUpdatesRoute,
  appAdminMapRoute: appAdminMapRoute,
  appAdminOrganizationsRoute: appAdminOrganizationsRouteWithChildren,
  appAdminPartnersRoute: appAdminPartnersRoute,
  appAdminRundataRoute: appAdminRundataRoute,
  appAdminSchoolsRoute: appAdminSchoolsRoute,
  appAdminSimulatorFleetRoute: appAdminSimulatorFleetRoute,
  appAdminSimulatorsRoute: appAdminSimulatorsRoute,
  appAdminStatsRoute: appAdminStatsRoute,
  appAdminToplistRoute: appAdminToplistRoute,
  appAdminUsersRoute: appAdminUsersRoute,
  appAdminIndexRoute: appAdminIndexRoute,
  appAdminBugBugIdRoute: appAdminBugBugIdRoute,
  appAdminCompetitionsIdRoute: appAdminCompetitionsIdRouteWithChildren,
  appAdminCompetitionsCreateRoute: appAdminCompetitionsCreateRoute,
  appAdminCompetitionsIndexRoute: appAdminCompetitionsIndexRoute,
  appAdminFrameratesIndexRoute: appAdminFrameratesIndexRoute,
}

const appAdminRouteRouteWithChildren = appAdminRouteRoute._addFileChildren(
  appAdminRouteRouteChildren,
)

interface appCoursesRouteRouteChildren {
  appCoursesIndexRoute: typeof appCoursesIndexRoute
  appCoursesTypeIndexRoute: typeof appCoursesTypeIndexRoute
}

const appCoursesRouteRouteChildren: appCoursesRouteRouteChildren = {
  appCoursesIndexRoute: appCoursesIndexRoute,
  appCoursesTypeIndexRoute: appCoursesTypeIndexRoute,
}

const appCoursesRouteRouteWithChildren = appCoursesRouteRoute._addFileChildren(
  appCoursesRouteRouteChildren,
)

interface appHomeRouteRouteChildren {
  appHomeNewsRoute: typeof appHomeNewsRoute
  appHomeStartRoute: typeof appHomeStartRoute
  appHomeStatsRoute: typeof appHomeStatsRoute
  appHomeYoutubeRoute: typeof appHomeYoutubeRoute
  appHomeIndexRoute: typeof appHomeIndexRoute
  appHomeAcademyIndexRoute: typeof appHomeAcademyIndexRoute
}

const appHomeRouteRouteChildren: appHomeRouteRouteChildren = {
  appHomeNewsRoute: appHomeNewsRoute,
  appHomeStartRoute: appHomeStartRoute,
  appHomeStatsRoute: appHomeStatsRoute,
  appHomeYoutubeRoute: appHomeYoutubeRoute,
  appHomeIndexRoute: appHomeIndexRoute,
  appHomeAcademyIndexRoute: appHomeAcademyIndexRoute,
}

const appHomeRouteRouteWithChildren = appHomeRouteRoute._addFileChildren(
  appHomeRouteRouteChildren,
)

interface appGroupsIdRouteRouteChildren {
  appGroupsIdCoursesRoute: typeof appGroupsIdCoursesRoute
  appGroupsIdDrivingHistoryRoute: typeof appGroupsIdDrivingHistoryRoute
  appGroupsIdTachographRoute: typeof appGroupsIdTachographRoute
  appGroupsIdIndexRoute: typeof appGroupsIdIndexRoute
}

const appGroupsIdRouteRouteChildren: appGroupsIdRouteRouteChildren = {
  appGroupsIdCoursesRoute: appGroupsIdCoursesRoute,
  appGroupsIdDrivingHistoryRoute: appGroupsIdDrivingHistoryRoute,
  appGroupsIdTachographRoute: appGroupsIdTachographRoute,
  appGroupsIdIndexRoute: appGroupsIdIndexRoute,
}

const appGroupsIdRouteRouteWithChildren =
  appGroupsIdRouteRoute._addFileChildren(appGroupsIdRouteRouteChildren)

interface appUsersIdRouteRouteChildren {
  appUsersIdCoursesRoute: typeof appUsersIdCoursesRoute
  appUsersIdDrivingRecordRoute: typeof appUsersIdDrivingRecordRoute
  appUsersIdProfileRoute: typeof appUsersIdProfileRoute
  appUsersIdTachographRoute: typeof appUsersIdTachographRoute
  appUsersIdIndexRoute: typeof appUsersIdIndexRoute
}

const appUsersIdRouteRouteChildren: appUsersIdRouteRouteChildren = {
  appUsersIdCoursesRoute: appUsersIdCoursesRoute,
  appUsersIdDrivingRecordRoute: appUsersIdDrivingRecordRoute,
  appUsersIdProfileRoute: appUsersIdProfileRoute,
  appUsersIdTachographRoute: appUsersIdTachographRoute,
  appUsersIdIndexRoute: appUsersIdIndexRoute,
}

const appUsersIdRouteRouteWithChildren = appUsersIdRouteRoute._addFileChildren(
  appUsersIdRouteRouteChildren,
)

interface appUsersCreateRouteRouteChildren {
  appUsersCreateImportRoute: typeof appUsersCreateImportRoute
  appUsersCreateNewRoute: typeof appUsersCreateNewRoute
  appUsersCreateIndexRoute: typeof appUsersCreateIndexRoute
}

const appUsersCreateRouteRouteChildren: appUsersCreateRouteRouteChildren = {
  appUsersCreateImportRoute: appUsersCreateImportRoute,
  appUsersCreateNewRoute: appUsersCreateNewRoute,
  appUsersCreateIndexRoute: appUsersCreateIndexRoute,
}

const appUsersCreateRouteRouteWithChildren =
  appUsersCreateRouteRoute._addFileChildren(appUsersCreateRouteRouteChildren)

interface appRouteRouteChildren {
  appAdminRouteRoute: typeof appAdminRouteRouteWithChildren
  appCoursesRouteRoute: typeof appCoursesRouteRouteWithChildren
  appHomeRouteRoute: typeof appHomeRouteRouteWithChildren
  appAboutRoute: typeof appAboutRoute
  appAcademyRoute: typeof appAcademyRoute
  appSimulatorsRoute: typeof appSimulatorsRoute
  appGroupsIdRouteRoute: typeof appGroupsIdRouteRouteWithChildren
  appUsersIdRouteRoute: typeof appUsersIdRouteRouteWithChildren
  appUsersCreateRouteRoute: typeof appUsersCreateRouteRouteWithChildren
  appGroupsCreateRoute: typeof appGroupsCreateRoute
  appSchoolClassesIdRoute: typeof appSchoolClassesIdRoute
  appSettingsIntegrationsRoute: typeof appSettingsIntegrationsRoute
  appSupportContactRoute: typeof appSupportContactRoute
  appSupportInstallationRoute: typeof appSupportInstallationRoute
  appGroupsIndexRoute: typeof appGroupsIndexRoute
  appSchoolClassesIndexRoute: typeof appSchoolClassesIndexRoute
  appSupportIndexRoute: typeof appSupportIndexRoute
  appUsersIndexRoute: typeof appUsersIndexRoute
  appCoursesTypePublicCourseUuidIndexRoute: typeof appCoursesTypePublicCourseUuidIndexRoute
  appCoursesTypePublicCourseUuidLessonsPublicLessonUuidRoute: typeof appCoursesTypePublicCourseUuidLessonsPublicLessonUuidRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appAdminRouteRoute: appAdminRouteRouteWithChildren,
  appCoursesRouteRoute: appCoursesRouteRouteWithChildren,
  appHomeRouteRoute: appHomeRouteRouteWithChildren,
  appAboutRoute: appAboutRoute,
  appAcademyRoute: appAcademyRoute,
  appSimulatorsRoute: appSimulatorsRoute,
  appGroupsIdRouteRoute: appGroupsIdRouteRouteWithChildren,
  appUsersIdRouteRoute: appUsersIdRouteRouteWithChildren,
  appUsersCreateRouteRoute: appUsersCreateRouteRouteWithChildren,
  appGroupsCreateRoute: appGroupsCreateRoute,
  appSchoolClassesIdRoute: appSchoolClassesIdRoute,
  appSettingsIntegrationsRoute: appSettingsIntegrationsRoute,
  appSupportContactRoute: appSupportContactRoute,
  appSupportInstallationRoute: appSupportInstallationRoute,
  appGroupsIndexRoute: appGroupsIndexRoute,
  appSchoolClassesIndexRoute: appSchoolClassesIndexRoute,
  appSupportIndexRoute: appSupportIndexRoute,
  appUsersIndexRoute: appUsersIndexRoute,
  appCoursesTypePublicCourseUuidIndexRoute:
    appCoursesTypePublicCourseUuidIndexRoute,
  appCoursesTypePublicCourseUuidLessonsPublicLessonUuidRoute:
    appCoursesTypePublicCourseUuidLessonsPublicLessonUuidRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

interface fullscreenGroupsIdEditRouteRouteChildren {
  fullscreenGroupsIdEditCoursesRoute: typeof fullscreenGroupsIdEditCoursesRoute
  fullscreenGroupsIdEditSettingsRoute: typeof fullscreenGroupsIdEditSettingsRoute
  fullscreenGroupsIdEditUsersRoute: typeof fullscreenGroupsIdEditUsersRoute
}

const fullscreenGroupsIdEditRouteRouteChildren: fullscreenGroupsIdEditRouteRouteChildren =
  {
    fullscreenGroupsIdEditCoursesRoute: fullscreenGroupsIdEditCoursesRoute,
    fullscreenGroupsIdEditSettingsRoute: fullscreenGroupsIdEditSettingsRoute,
    fullscreenGroupsIdEditUsersRoute: fullscreenGroupsIdEditUsersRoute,
  }

const fullscreenGroupsIdEditRouteRouteWithChildren =
  fullscreenGroupsIdEditRouteRoute._addFileChildren(
    fullscreenGroupsIdEditRouteRouteChildren,
  )

interface fullscreenUsersIdEditRouteRouteChildren {
  fullscreenUsersIdEditAccountRoute: typeof fullscreenUsersIdEditAccountRoute
  fullscreenUsersIdEditCoursesRoute: typeof fullscreenUsersIdEditCoursesRoute
  fullscreenUsersIdEditPersonalInfoRoute: typeof fullscreenUsersIdEditPersonalInfoRoute
}

const fullscreenUsersIdEditRouteRouteChildren: fullscreenUsersIdEditRouteRouteChildren =
  {
    fullscreenUsersIdEditAccountRoute: fullscreenUsersIdEditAccountRoute,
    fullscreenUsersIdEditCoursesRoute: fullscreenUsersIdEditCoursesRoute,
    fullscreenUsersIdEditPersonalInfoRoute:
      fullscreenUsersIdEditPersonalInfoRoute,
  }

const fullscreenUsersIdEditRouteRouteWithChildren =
  fullscreenUsersIdEditRouteRoute._addFileChildren(
    fullscreenUsersIdEditRouteRouteChildren,
  )

interface fullscreenRouteRouteChildren {
  fullscreenWelcomeRoute: typeof fullscreenWelcomeRoute
  fullscreenGroupsIdEditRouteRoute: typeof fullscreenGroupsIdEditRouteRouteWithChildren
  fullscreenUsersIdEditRouteRoute: typeof fullscreenUsersIdEditRouteRouteWithChildren
  fullscreenHomeAcademyLectureIdSegmentIdRoute: typeof fullscreenHomeAcademyLectureIdSegmentIdRoute
  fullscreenAdminTicketsIdScreenshotBugIdRoute: typeof fullscreenAdminTicketsIdScreenshotBugIdRoute
}

const fullscreenRouteRouteChildren: fullscreenRouteRouteChildren = {
  fullscreenWelcomeRoute: fullscreenWelcomeRoute,
  fullscreenGroupsIdEditRouteRoute:
    fullscreenGroupsIdEditRouteRouteWithChildren,
  fullscreenUsersIdEditRouteRoute: fullscreenUsersIdEditRouteRouteWithChildren,
  fullscreenHomeAcademyLectureIdSegmentIdRoute:
    fullscreenHomeAcademyLectureIdSegmentIdRoute,
  fullscreenAdminTicketsIdScreenshotBugIdRoute:
    fullscreenAdminTicketsIdScreenshotBugIdRoute,
}

const fullscreenRouteRouteWithChildren = fullscreenRouteRoute._addFileChildren(
  fullscreenRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  appRouteRoute: appRouteRouteWithChildren,
  fullscreenRouteRoute: fullscreenRouteRouteWithChildren,
  ActivateRoute: ActivateRoute,
  LoginRoute: LoginRoute,
  CourseEditorPublicUuidRoute: CourseEditorPublicUuidRoute,
  OauthFortnoxCallbackRoute: OauthFortnoxCallbackRoute,
  OauthGithubCallbackRoute: OauthGithubCallbackRoute,
  OauthPipedriveCallbackRoute: OauthPipedriveCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
